import React from "react";
import { NavLink } from "react-router-dom";
import FormatPrice from "../helper/FormatPrice";

const ProductFilterTable = (curElem) => {
  const {
    product_sku,
    carat,
    product_image,
    product_price,
    cut_name,
    shape_name,
    color_name,
    product_name,
    clarity_name,
  } = curElem;
  return (
    <>
      <tr>
        <td>
          <img width={50} className="" alt="Diamond" src={product_image[0]} />
        </td>
        <td>{product_name}</td>
        <td>{clarity_name}</td>
        <td>{shape_name}</td>
        <td>{carat}</td>
        <td>{cut_name}</td>
        <td>{color_name}</td>
        <td>{<FormatPrice price={product_price} />}</td>
        <td className="btn-td">
          <NavLink
            to={`/singleproduct/${product_sku}`}
            className="btn__link ms-0"
          >
            Details
          </NavLink>
        </td>
      </tr>
    </>
  );
};

export default ProductFilterTable;
